import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';

import Header from '../../components/Header';
import { configureDomainRequirement } from '../../store/signup/signupAction';

/**
 * Register domain component
 * @param {*} param0
 */
const RegisterDomain = ({ configureDomainRequirement }) => {
    const history = useHistory();
    /**
     * Need domain action
     */
    const needDomainAction = () => {
        configureDomainRequirement(true);
        history.push('/registration');
    };
    /**
     * Donot need domain action
     */
    const doNotNeedDomainAction = () => {
        configureDomainRequirement(false);
        history.push('/need-mail');
    };
    return (
        <div className="container">
            <Header />
            <div className="type1-container reg-domain-container">
                <h1>Would you like to register a domain for your business?</h1>

                <div className="centerd-btn-block">
                    <button
                        onClick={() => needDomainAction()}
                        className="btn-primary"
                    >
                        Yes, Proceed
                    </button>
                    <button
                        onClick={() => doNotNeedDomainAction()}
                        className="btn-secondary"
                    >
                        No
                    </button>
                </div>

                <div className="faq-section">
                    <h2>FAQ</h2>
                    <div className="faq-item">
                        <h3>What is a business domain?</h3>
                        <p>
                            A business domain is the unique name mapped to your
                            numeric IP address. Visitors can enter your domain
                            name in their browsers' URL bars to land on your
                            website. It helps you establish a successful web
                            presence and prevent you from getting lost in the
                            cyber world.
                        </p>
                    </div>
                    <div className="faq-item">
                        <h3>How does a business domain help my business?</h3>
                        <p>
                            Apart from establishing your brand, a business
                            domain helps you :
                        </p>
                        <ul>
                            <li>Build professional credibility</li>
                            <li>Safeguard your copyrights and trademarks.</li>
                            <li>
                                Rank on search engines and drive traffic to your
                                website.
                            </li>
                            <li>
                                Add mobility to your business while switching
                                web hosting services, servers, and more.
                            </li>
                            <li>
                                Establish your business as forward-thinking and
                                tech-savvy.
                            </li>
                        </ul>
                        <p>
                            We request you to set up your business domain to
                            continue with InfinCE and achieve the highest level
                            of customization possible through a branded
                            workspace, business email, and more.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (store) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    needMailServer: get(store, 'signupReducer.needMailServer', null),
});
const mapDispatchToProps = {
    configureDomainRequirement,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterDomain);
